// Bảng giá các gói: NGUỒN DUY NHẤT cho trang /subscription và các popup nâng cấp.
export const PLANS = [
  {
    id: '1month',
    code: '1T',
    name: '1 Tháng',
    price: 29000,
    originalPrice: 60000,
    savings: 31000,
    duration: '30 ngày',
    popular: false,
    features: [
      'Truy cập đầy đủ công thức',
      'Lập kế hoạch thực đơn',
      'Tính toán chi phí',
      'Quản lý nguyên liệu'
    ]
  },
  {
    id: '3months',
    code: '3T',
    name: '3 Tháng',
    price: 79000,
    originalPrice: 180000,
    savings: 101000,
    duration: '90 ngày',
    popular: true,
    features: [
      'Tất cả tính năng gói 1 tháng',
      'Tiết kiệm 56% so với trả theo tháng',
      'Hỗ trợ ưu tiên',
      'Cập nhật công thức mới'
    ]
  },
  {
    id: '12months',
    code: '12T',
    name: '12 Tháng',
    price: 269000,
    originalPrice: 720000,
    savings: 451000,
    duration: '365 ngày',
    popular: false,
    features: [
      'Tất cả tính năng gói 3 tháng',
      'Tiết kiệm 63% so với trả theo tháng',
      'Hỗ trợ VIP 24/7',
      'Tính năng cao cấp độc quyền'
    ]
  }
];

export const formatVnd = (amount) => `${amount.toLocaleString('vi-VN')}₫`;

// Giá gói rẻ nhất (gói 1 tháng) - dùng trong câu chữ popup
export const cheapestPlan = () => PLANS.reduce((min, p) => (p.price < min.price ? p : min), PLANS[0]);
